module.exports = __webpack_public_path__ + "img/live-heat-title.c20a5b46.png";